import {Component, forwardRef, Host, Input, OnInit, Optional, SkipSelf} from '@angular/core';
import {FORM_GROUP_CONTEXT} from "../form-group-context.tokens";
import {ProductService} from '../../../services/product.service';
import {ProjectService} from '../../../services/project.service';
import {StoreAppService} from '../../../services/store-app.service';
import {FormGroupExtension} from "../extensions/form-group-extension/form-group.extension";
import {ControlContainer, NG_VALUE_ACCESSOR} from "@angular/forms";
import {StoreCollectionService} from '../../../services/store-collection.service';
import {StoreKeyService} from '../../../services/store-key.service';

@Component({
  selector: 'form-group-select',
  templateUrl: './form-group-select.component.html',
  providers: [
    {
      provide: FORM_GROUP_CONTEXT,
      useExisting: FormGroupSelectComponent
    },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormGroupSelectComponent),
      multi: true,
    },
  ]
})
export class FormGroupSelectComponent extends FormGroupExtension implements OnInit {

  @Input() placeholder: string;
  @Input() bindLabel: string;
  @Input() bindValue: string;
  @Input() multiple: boolean;
  items: any[];
  @Input('items') set items$(value: any) {
    this.items = value;
  }
  @Input() searchable: boolean = false;
  @Input() hideSelected: boolean = true;
  @Input() clearable: boolean = true;
  @Input() entity: string;
  storeQuery: any;
  query: any = {};
  // @Input('query') set query$(value: any) {
  //   if (value) {
  //     this.query = Object.assign(this.query, value);
  //     this.getEntities();
  //   }
  // }
  @Input('storeQuery') set storeQuery$(value: any) {
    if (value === null || (value?.store || value?.parentStore)) {
      this.storeQuery = true;

      if (value) {
        if (value.store) value.store = parseInt(value.store);
        if (value.parentStore) value.parentStore = parseInt(value.parentStore);

        this.query = Object.assign(this.query, {filters: value});
      }
      this.getEntities();
    }
  }

  private _service: any;


  constructor(private _product: ProductService,
              private _store: StoreAppService,
              private _storeCollection: StoreCollectionService,
              private _project: ProjectService,
              private _storeKey: StoreKeyService,
              @Optional() @Host() @SkipSelf() protected controlContainer: ControlContainer) {
    super(controlContainer);
  }

  ngOnInit(): void {
    if (this.entity) this.setService();

    this.registerControl();
  }

  setService() {
    // let service
    switch (this.entity) {
      case 'product':
        this._service = this._product;
        break;
      case 'store':
        this._service = this._store;
        break;
      case 'storeKey':
        this._service = this._storeKey;
        break;
      case 'storeCollection':
        this._service = this._storeCollection;
        break;
      case 'project':
        this._service = this._project;
        break;
      default:
        break;
    }
    this.getEntities();
  }

  getEntities() {
    if (this._service && this.storeQuery) {

      this._service.index(this.query)
        .subscribe((res: any) => {
            this.items = res.array;
          },
          err => {
          }
        );
    }
  }

  onSearch(event) {
    this.query.search = event.term;
    this.getEntities();
  }

  setValue(value) {
    if (Array.isArray(value)) {
      this.value = value.slice().map(item => item.hasOwnProperty(this.bindValue) ? item[this.bindValue] : item);
    } else if (value) {
      this.value = value.hasOwnProperty(this.bindValue) ? value[this.bindValue] : value;
    }
  }
}
